import { useState } from 'react';
import { CustomPopover, useCustomPopoverHook } from '@/components/popover/CustomPopover';
import { useLinkCategoryContextValueHook } from '../../../../../../contexts/LinkCategoryContextProvider';
import { ModuleCard } from '../weget-module-card/ModuleCard';
import { TEXT_FONTS, TextStyleFields, pageFontFamily, resolveTextStyle, textStyleProps, useTextModuleFonts } from './textStyles';
import * as St from './WegetTextItem.styled';
import CustomBlockButton from '@/components/button/CustomBlockButton';
import { CustomRatioImage } from '@/components/image/CustomRatioImage';
import { useUserPageContextValueHook } from '@/contexts/UserPageContextProvider';
import { customToast } from '@/components/toast/custom-react-toastify/v1';
import { CustomDialog } from '@/components/dialog/v1/CustomDialog';
import { CustomLabelTextarea } from '@/components/textarea/CustomLabelTextarea';
import CustomSelect from '@/components/select/default/v1/CustomSelect';

export function WegetTextItem({
    moduleItemIndex,
    moduleItem,
    onReqDelete,
    onReqChangeIsHide,
    onReqUpdateInfo
}) {
    const linkCategoryContextValueHook = useLinkCategoryContextValueHook();
    const descriptionPopoverHook = useCustomPopoverHook();
    const thumbnailPopoverHook = useCustomPopoverHook();

    const [updateLinkItemModalOpen, setUpdateLinkItemModalOpen] = useState(false);

    const textConfig = moduleItem?.textConfig;

    const toggleUpdateLinkItemModalOpen = (bool) => {
        setUpdateLinkItemModalOpen(bool);
    }


    const handleSubmitUpdateLinkItem = (updateForm) => {
        updateForm = {
            id: moduleItem?.id,
            ...updateForm
        }

        onReqUpdateInfo(updateForm);
        toggleUpdateLinkItemModalOpen(false);
    }
    return (
        <>
            <ModuleCard
                id={moduleItem.id}
                index={moduleItemIndex}
                isHide={moduleItem?.isHide}
                badgeIcon='/assets/icons/text_default_mainColor.svg'
                badgeLabel='텍스트'
                categoryName={moduleItem?.linkCategoryId && linkCategoryContextValueHook?.content?.find(r => r.id === moduleItem?.linkCategoryId)?.name}
                onEdit={() => toggleUpdateLinkItemModalOpen(true)}
                onToggleHide={onReqChangeIsHide}
                onDelete={onReqDelete}
            >
                <TextPreview textConfig={textConfig} />
            </ModuleCard>
            {descriptionPopoverHook?.anchorEl &&
                <CustomPopover
                    anchorEl={descriptionPopoverHook?.anchorEl}
                    onClose={() => descriptionPopoverHook?.closePopover()}
                    layoutStyle={!descriptionPopoverHook?.element ? { color: '#808080' } : {}}
                >
                    {descriptionPopoverHook?.element ? descriptionPopoverHook?.element : '등록된 설명이 없습니다.'}
                </CustomPopover>
            }

            {thumbnailPopoverHook?.anchorEl &&
                <CustomPopover
                    anchorEl={thumbnailPopoverHook?.anchorEl}
                    onClose={() => thumbnailPopoverHook?.closePopover()}
                    layoutStyle={!thumbnailPopoverHook?.element ? { color: '#808080' } : {}}
                >
                    {thumbnailPopoverHook?.element ?
                        (
                            <St.ThumbnailPopoverElement>
                                <CustomRatioImage>
                                    <CustomRatioImage.Image src={thumbnailPopoverHook?.element} />
                                </CustomRatioImage>
                            </St.ThumbnailPopoverElement>
                        )
                        :
                        '등록된 썸네일이 없습니다.'
                    }
                </CustomPopover>
            }

            {(updateLinkItemModalOpen && moduleItem) &&
                <UpdateModuleModal
                    open={updateLinkItemModalOpen}
                    moduleItem={moduleItem}
                    toggleOpenClose={toggleUpdateLinkItemModalOpen}
                    onConfirm={(body) => handleSubmitUpdateLinkItem(body)}
                />
            }
        </>
    );
}

/** 목록 카드: 정렬·폰트·크기를 적용해 보여 주고, 색은 흰 카드에서 안 보일 수 있어 점으로 표시 */
function TextPreview({ textConfig }) {
    useTextModuleFonts();
    const userPage = useUserPageContextValueHook()?.userPage;
    const style = resolveTextStyle(textConfig);
    const props = textStyleProps(style, null, pageFontFamily(userPage));

    return (
        <div className="flex flex-col gap-1.5">
            <p className={`line-clamp-3 whitespace-pre-line break-words text-gray-900 ${props.className}`} style={{ ...props.style, color: undefined }}>{textConfig?.text}</p>
            <p className="flex items-center gap-1.5 text-[11px] text-gray-400">
                {style.color && <span className="h-3 w-3 rounded-full ring-1 ring-black/10" style={{ background: style.color }} aria-label={`색상 ${style.color}`} />}
                {[TEXT_FONTS.find(f => f.value === style.font)?.label, style.color ? null : '페이지 기본 색'].filter(Boolean).join(' · ')}
            </p>
        </div>
    );
}

function UpdateModuleModal({
    open,
    moduleItem,
    toggleOpenClose,
    onConfirm,
}) {
    const userPageContextValueHook = useUserPageContextValueHook();
    const linkCategoryContextValueHook = useLinkCategoryContextValueHook();

    const textConfig = moduleItem?.textConfig;

    const [text, setText] = useState(textConfig?.text);
    const [textColorHex, setTextColorHex] = useState(textConfig?.textColorHex);
    const [textStyle, setTextStyle] = useState(resolveTextStyle(textConfig));
    const [linkCategoryId, setLinkCategoryId] = useState(linkCategoryContextValueHook?.content?.find(r => r.id === moduleItem?.linkCategoryId)?.id || '');

    const handleChangeText = (e) => {
        const value = e.target.value;
        setText(value);
    }

    const handleChangeLinkCategoryId = (e) => {
        const value = e.target.value;

        setLinkCategoryId(value || '');
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (text?.length < 1 || text?.length > 500) {
            customToast.error('텍스트는 1-500자 내외로 입력해 주세요.');
            return;
        }

        let body = {
            ...moduleItem,
            type: 'TEXT',
            linkCategoryId: linkCategoryContextValueHook?.content?.find(r => r?.id === linkCategoryId)?.id || '',
            userPageId: userPageContextValueHook?.userPage?.id,
            textConfig: {
                text: text,
                textColorHex: textColorHex,
                ...textStyle,
            }
        }
        onConfirm(body);
    }

    return (
        <>
            <CustomDialog open={open} onClose={() => toggleOpenClose(false)} maxWidth='sm'>
                <St.UpdateModuleContainer>
                    <CustomDialog.Header style={{ marginBottom: '20px' }}>
                        <CustomDialog.Header.Fake />
                        <CustomDialog.Header.Title>텍스트 모듈</CustomDialog.Header.Title>
                        <CustomDialog.Header.Close onClick={() => toggleOpenClose(false)} />
                    </CustomDialog.Header>
                    <div className='wrapper'>
                        <div className='textareaBox'>
                            <CustomLabelTextarea
                                labelElement={<><span style={{ color: 'var(--redColor1)' }}>*</span> 텍스트</>}
                                value={text || ''}
                                onChange={(e) => handleChangeText(e)}
                                maxLength={500}
                            />
                            <div className='counter'>{text?.length} / 500</div>
                        </div>
                        <TextStyleFields text={text} style={textStyle} onChange={(patch) => setTextStyle(prev => ({ ...prev, ...patch }))} />
                        <div className='wrapper__selectBox'>
                            <CustomSelect
                                value={linkCategoryId}
                                onChange={(e) => handleChangeLinkCategoryId(e)}
                            >
                                <option value=''>전체</option>
                                {linkCategoryContextValueHook?.content?.map(linkCategory => {
                                    return (
                                        <option key={linkCategory?.id} value={linkCategory?.id}>{linkCategory?.name}</option>
                                    );
                                })}
                            </CustomSelect>
                            <label>카테고리{linkCategoryId && <span style={{ color: 'var(--redColor1)', paddingLeft: '10px' }}>* 카테고리가 선택 되었어요!</span>}</label>
                        </div>
                        <div className='wrapper__footerButtonGroup'>
                            <CustomBlockButton
                                type='button'
                                onClick={(e) => handleSubmit(e)}
                            >
                                수정
                            </CustomBlockButton>
                        </div>
                    </div>
                </St.UpdateModuleContainer>
            </CustomDialog>
        </>
    )
}